import React from 'react'

export default function AddContacts() {
  return (
    <div>
      <h1>Add Contaict</h1>
    </div>
  )
}
